<template>
  <component
    v-if="uiStore.drawer.component"
    :is="uiStore.drawer.component"
    :show="uiStore.drawer.isOpen"
    v-bind="uiStore.drawer.props"
    @close="uiStore.closeDrawer()"
    @schedule="(wo) => uiStore.drawer.props.onSchedule?.(wo)"
  />
</template>

<script>
  import { defineComponent } from 'vue';
  import { useUIStore } from '@/store/uiStore';

  export default defineComponent({
    name: 'DrawerHandler',
    setup() {
      const uiStore = useUIStore();
      return { uiStore };
    },
  });
</script>
